// constants.js
export const NUMERIC = /\d/;
export const ALPHA_NUMERIC = /^[a-zA-Z0-9]*$/;
export const ALPHA_NUMERIC_WITH_SYMBOLS = /^[a-zA-Z0-9@&]*$/;
export const ALPHA_NUMERIC_FOR_NAMING = /^[a-zA-Z0-9@&\-_\s]*$/;
// export const ALPHA_NUMERIC_FOR_COMPANY_NAME = /^[a-zA-Z0-9@&\-_'\/\s.,]*$/;
export const ALPHA_ONLY = /^[a-zA-Z]*$/;
export const ALPHA_WITH_SPACES = /^[a-zA-Z\s]*$/;
export const PIN_RESTRUCT = /^\d{4}$/;
export const NUMERIC_WITH_DOT = /[0-9.]/;
export const PASSWORD_VALIDATION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
export const GST_VALIDATION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
export const ALPHA_NUMERIC_WITH_SPACES = /^[a-zA-Z0-9\s]*$/;
export const ALPHA_NUMERIC_FOR_NAMING_AND_SYMPOLS = /^[a-zA-Z0-9@&\-_\s.,/]*$/;

// Status code
export const SAVE_SUCCESS_CODE = '201';
export const UPDATE_SUCCESS_CODE = '202';
export const DELETE_SUCCESS_CODE = '203';
export const EDITLOAD_SUCCESS_CODE = '206';
export const USER_SUCCESS_CODE = '206';
export const SERVICE_CATEGORY_SUCCESS_CODE = '206';
export const SERVICE_REVIEW_SUCCESS_CODE = '228';
export const ADMIN_SOURCE = 1;
export const DATAMANAGEMENT_SUCCESS_CODE = '214';
export const SUCCESS_CODE = '200';
export const ACTIVE_STATUS = 1;
export const INACTIVE_STATUS = 2;
export const ADMIN_SCREEN_ID=2;
export const ADMIN_SCREEN_ID_CITY=3;
export const ADMIN_VISIT_HISTORY=5;
export const LIST_NO_RECORD_CODE = '208';
export const SOMETHING_WENT_WRONG = 'Something  went wrong';
export const MANDATORY_FIELD = 'Please fill all mandatory fields';
export const IMAGE_FILE_SIZE = 'File size should not exceed 500KB';
export const IMAGE_FILE_FORMAT = 'Unsupported file format';
export const NO_RECORDS_FOUND = '208';
export const PDFGENERATED = '212';
export const EXPIRED_TOKEN = '498';
export const UNAUTHORIZED = '103';
export const NETWORK_ERROR_STATUS = 'ERR_NETWORK';
export const BAD_REQUEST_ERROR_STATUS = 'ERR_BAD_REQUEST';
export const NETWORK_ERROR = 'Server Not Reachable';
export const BAD_REQUEST_ERROR = 'Bad Request';
export const NO_RECORD_FOUND = '208';
export const INVALID_CSRF = '403';
export const LOGIN_SUCCESS = '101';
export const SALON_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
};
export const REVIEWS_PER_PAGE = 32;
/** List screen ORDER FLAG */
export const LIST_ORDER_FLAG = 2;
export const DROPDOWN_ORDER_FLAG = 1;
export const ITEM_GROUP_MENU_ID = 3;
export const COMPANY_CONFING_MENU_ID = 2;
export const USER_MENU_ID = 4;

export const USER_ROLE = [
    { role_id: 1, role_name: 'Admin' },
];

export const ratingOptions = [
    { label: 'All', value: null },
    { label: '4', value: 4 },
    { label: '3', value: 3 },
    { label: '2', value: 2 },
    { label: '1', value: 1 },
];

export const yearOptions = [
    { label: 'All', value: 0 },
    { label: '2026', value: 2026 },
    { label: '2025', value: 2025 },
    { label: '2024', value: 2024 },
    { label: '2023', value: 2023 },
    { label: '2022', value: 2022 },
    { label: '2021', value: 2021 },
    { label: '2020', value: 2020 },
];
export const customerStatusOptions = [
    { id: '0', label: 'All Status' },
    { id: 1, label: 'Active' },
    { id: 2, label: 'Blocked' },
];
export const SERVICE_REQUEST_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
};
export const REVIEW_UPDATE_STATUS = {
    INACTIVE: 0,
    PENDING: 2,
    CANCEL: 1,
};
export const LIST_ACTIVE_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

//export const DASHBOARD_MENU_ID = 1;

export const LIST = 1;
export const CREATE = 2;
export const UPDATE = 3;
export const DELETE = 4;
export const CANCEL = 5;
export const APPROVE = 6;
export const REJECT = 7;

export const TN_STATE_CODE = '33';
export const INV_DOWNLOAD_PATH = 'invoices/';
export const UPLOADED_IMAGE_PATH = 'public/uploads/';
export const EXPORT_DC_PRINT = 'public/pdfs/';
export const EXPORT_LABEL_PRINT = 'public/';
export const DEFAULT_LOGIN = {
    user_role: {
        'parent_menu': [
            7, 6,
            5,
            4,
            3,
            2,
            1,
            8,
        ],
        'menu_access': [
            {
                'parent_id': 1,
                'menu_id': 1,
                'access_level': [
                    1,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 2,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 3,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 4,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 5,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 6,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 7,
                'access_level': [
                    1,
                    3,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 8,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 9,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 10,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 2,
                'menu_id': 11,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 3,
                'menu_id': 12,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                    5,
                    6,
                ],
            },
            {
                'parent_id': 4,
                'menu_id': 13,
                'access_level': [
                    5,
                    6,
                ],
            },
            {
                'parent_id': 5,
                'menu_id': 14,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 6,
                'menu_id': 15,
                'access_level': [
                    1,
                    4,
                    3,
                    2,
                ],
            },
            {
                'parent_id': 7,
                'menu_id': 16,
                'access_level': [
                    1,
                ],
            },
            {
                'parent_id': 7,
                'menu_id': 17,
                'access_level': [
                    1,
                ],
            },
            {

                'parent_id': 8,
                'menu_id': 18,
                'access_level': [
                    1,
                    2,
                    3,
                    4,
                ],
            },
        ],
    },
};

export const NAVIGATIONS =
    [
        { name: 'Dashboard', path: '/dashboard', menu_id: 5, icon: 'PieChart' },
        {
            name: 'Masters',
            icon: 'masters',
            parent_menu_id: 1,
            children: [
                { name: 'User Master', path: '/user-master', menu_id: 4, icon: 'GroupOutlined' },
                { name: 'Sales Rep Master', path: '/sales-rep-master', menu_id: 20, icon: 'Diversity3' },
                { name: 'Party Master', path: '/party-master', menu_id: 21, icon: 'Person' },
            ],
        },
        { name: 'Visit History', path: '/visit-history', menu_id: 22, icon: 'HistoryOutlined' },
    ];
